<template>
  <div class="container comments">
    <h3
      class="comments_title title_font text-center text-sm-left"
      id="comments_title"
    >{{$t('comment.customer_review')}}</h3>
    <v-comments-write-box
      :review_count="review_count"
      :average_rating="average_rating"
      :rating_count="rating_count"
      :product_id="product_id"
    ></v-comments-write-box>
    <v-comments-item-box
      :comment="comment"
      :comments="comments"
      :product_id="product_id"
    ></v-comments-item-box>
  </div>
</template>
<script>
import vCommentsWriteBox from "./commentsWriteBox";
import vCommentsItemBox from "./commentsItemBox";
export default {
  props: [
    "comment",
    "review_count",
    "average_rating",
    "rating_count",
    "comments",
    "product_id",
  ],
  data() {
    return {};
  },
  components: {
    vCommentsWriteBox,
    vCommentsItemBox
  }
};
</script>
<style scoped lang='scss'>
.comments {
  .comments_title {
    font-size: 24px;
    padding: 20px 0;
    margin: 0;
    text-align: left;
    text-transform: capitalize;
    font-weight: 400;
  }
}
</style>